(function () {
  'use strict';

  var currencyToken = '(?:\\b(?:SAR|SR)\\b|ر\\s*\\.?\\s*س\\s*\\.?)';
  var digit = '[0-9\\u0660-\\u0669\\u06F0-\\u06F9]';
  var amount = '[-\\u2212]?' + digit + '+(?:[.,\\u066B\\u066C]' + digit + '+)*';
  var pricePattern = new RegExp(
    '(?:' + currencyToken + '\\s*(' + amount + ')|(' + amount + ')\\s*' + currencyToken + ')',
    'giu'
  );
  var ignoredParent = 'script, style, textarea, input, select, option, noscript, template, code, pre, svg, [data-klik-riyal-ignore], .klik-riyal-price';

  function localizeStartingLabels(root) {
    var scope = root && root.querySelectorAll ? root : document;
    var isArabic = window.location.hostname.toLowerCase().indexOf('ar.') === 0 || (document.documentElement.lang || '').toLowerCase().indexOf('ar') === 0;
    var expected = isArabic ? 'يبدأ من' : 'From';
    var labels = [];
    if (root && root.nodeType === Node.ELEMENT_NODE && root.matches('[data-klik-starting-label]')) labels.push(root);
    Array.prototype.push.apply(labels, scope.querySelectorAll('[data-klik-starting-label]'));
    labels.forEach(function (label) {
      if (label.textContent !== expected) label.textContent = expected;
      label.setAttribute('data-wg-notranslate', '');
    });
  }

  function createPrice(amountText) {
    var price = document.createElement('span');
    var symbol = document.createElement('span');
    var value = document.createElement('span');

    price.className = 'klik-riyal-price';
    price.setAttribute('dir', 'ltr');

    symbol.className = 'klik-riyal-symbol';
    symbol.setAttribute('role', 'img');
    symbol.setAttribute('aria-label', 'Saudi riyal');

    value.className = 'klik-riyal-amount';
    value.textContent = amountText;

    price.appendChild(symbol);
    price.appendChild(value);
    return price;
  }

  function replaceTextNode(node) {
    var parent = node.parentElement;
    var text = node.nodeValue;
    var fragment;
    var match;
    var lastIndex = 0;

    if (!parent || !text) return;

    pricePattern.lastIndex = 0;
    match = pricePattern.exec(text);
    if (!match) return;
    if (parent.closest(ignoredParent)) return;

    fragment = document.createDocumentFragment();
    do {
      fragment.appendChild(document.createTextNode(text.slice(lastIndex, match.index)));
      fragment.appendChild(createPrice(match[1] || match[2]));
      lastIndex = match.index + match[0].length;
      match = pricePattern.exec(text);
    } while (match);

    fragment.appendChild(document.createTextNode(text.slice(lastIndex)));
    node.parentNode.replaceChild(fragment, node);
  }

  function process(root) {
    var walker;
    var nodes = [];
    var current;

    if (!root) return;
    if (root.nodeType === Node.TEXT_NODE) {
      if (root.parentElement && root.parentElement.matches('[data-klik-starting-label]')) localizeStartingLabels(root.parentElement);
      replaceTextNode(root);
      return;
    }
    if (root.nodeType !== Node.ELEMENT_NODE || root.matches(ignoredParent)) return;
    localizeStartingLabels(root);

    walker = document.createTreeWalker(root, NodeFilter.SHOW_TEXT);
    while ((current = walker.nextNode())) nodes.push(current);
    nodes.forEach(replaceTextNode);
  }

  function start() {
    var body = document.body;
    var observer;

    if (!body) return;

    process(body);
    var pending = new Set(), scheduled = false;
    function flush() {
      scheduled = false;
      var roots = Array.from(pending), rootSet = new Set(roots); pending.clear();
      roots.forEach(function (root) {
        if (!root.isConnected) return;
        for (var parent = root.parentNode; parent; parent = parent.parentNode) if (rootSet.has(parent)) return;
        process(root);
      });
    }
    observer = new MutationObserver(function (mutations) {
      mutations.forEach(function (mutation) {
        if (mutation.type === 'characterData') {
          pending.add(mutation.target);
          return;
        }
        mutation.addedNodes.forEach(function (node) { pending.add(node); });
      });
      if (pending.size && !scheduled) { scheduled = true; requestAnimationFrame(flush); }
    });
    observer.observe(body, {
      childList: true,
      subtree: true,
      characterData: true
    });
  }

  if (document.body) {
    start();
  } else {
    document.addEventListener('DOMContentLoaded', start, { once: true });
  }
})();
